import getAll from './GetAll';

export default {
  getAll,
};
